"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../../../helpers");
var IcAndroid_1 = __importDefault(require("../assets/IcAndroid"));
var IcBlog_1 = __importDefault(require("../assets/IcBlog"));
var IcFacebook_1 = __importDefault(require("../assets/IcFacebook"));
var IcInstagram_1 = __importDefault(require("../assets/IcInstagram"));
var IcIos_1 = __importDefault(require("../assets/IcIos"));
var IcLinkedin_1 = __importDefault(require("../assets/IcLinkedin"));
var IcTwitter_1 = __importDefault(require("../assets/IcTwitter"));
var IcYoutube_1 = __importDefault(require("../assets/IcYoutube"));
var LogoHorizontalEs_1 = __importDefault(require("../assets/LogoHorizontalEs"));
var configuration = {
    copyright: {
        link: {
            props: {
                href: '//es.privalia.com/microsites/index',
                title: 'Privalia'
            }
        },
        logo: LogoHorizontalEs_1.default,
        sentence: "Copyright \u00A9 Privalia Venta Directa S.A. 2006-" + helpers_1.getCurrentYear()
    },
    main: {
        about: {
            links: [{
                    label: '¿Qué es Privalia?',
                    props: {
                        href: '//es.privalia.com/public/about',
                        title: '¿Qué es Privalia?'
                    }
                }, {
                    label: 'Descubre más sobre Veepee',
                    props: {
                        href: '//www.veepee.es',
                        style: {
                            color: '#ec008c'
                        },
                        target: '_blank',
                        title: 'Descubre más sobre Veepee'
                    }
                }, {
                    label: 'Política de privacidad',
                    props: {
                        onClick: function () {
                            window.open('https://es.privalia.com/front/get/doc/politica-de-privacidad.pdf?v=201906191410', 'popup', 'width=600,height=600');
                        },
                        target: '_blank',
                        title: 'Política de privacidad'
                    }
                }, {
                    label: 'Políticade cookies',
                    props: {
                        onClick: function () {
                            window.open('https://es.privalia.com/front/get/doc/politica-de-cookies.pdf?v=201906191410', 'popup', 'width=600,height=600');
                        },
                        target: '_blank',
                        title: 'Política de cookies'
                    }
                }, {
                    label: 'Condiciones de uso y venta',
                    props: {
                        onClick: function () {
                            window.open('https://es.privalia.com/front/get/doc/condiciones-de-uso-y-venta.pdf?v=201906191410', 'popup', 'width=600,height=600');
                        },
                        target: '_blank',
                        title: 'Condiciones de uso y venta'
                    }
                }],
            title: 'Sobre Privalia'
        },
        awards: {
            awards: ['Website del\nAño 2015', 'Mejor Webshop\nMobile 2014'],
            title: 'Reconocimientos'
        },
        contact: {
            links: [{
                    label: 'Ayuda',
                    props: {
                        href: '//es.privalia.com/help/indexpub',
                        title: 'Ayuda'
                    }
                }, {
                    label: 'Blog',
                    props: {
                        href: '//blog.es.privalia.com',
                        target: '_blank',
                        title: 'Blog'
                    }
                }, {
                    label: 'Prensa y comunicación',
                    props: {
                        href: '//pressroom.privalia.com/spain',
                        target: '_blank',
                        title: 'Prensa y comunicación'
                    }
                }],
            title: 'Contacta con nosotros'
        },
        premium: {
            link: {
                label: 'Hazte Premium',
                props: {
                    href: '//es.privalia.com/public/premium/',
                    title: 'Hazte Premium'
                }
            },
            sentence: 'Sácale todo el partido a Privalia.',
            title: 'Premium'
        }
    },
    top: {
        left: {
            links: [{
                    icon: IcIos_1.default,
                    label: 'iOS',
                    props: {
                        href: '//es.privalia.com/public/mobile#slide2',
                        title: 'iOS'
                    }
                }, {
                    icon: IcAndroid_1.default,
                    label: 'Android',
                    props: {
                        href: '//es.privalia.com/public/mobile#slide1',
                        title: 'Android'
                    }
                }],
            title: 'Descárgate nuestra app'
        },
        right: {
            links: [{
                    icon: IcFacebook_1.default,
                    props: {
                        href: '//www.facebook.com/privalia.es',
                        target: '_blank',
                        title: 'Privalia Facebook'
                    }
                }, {
                    icon: IcTwitter_1.default,
                    props: {
                        href: '//twitter.com/privalia_es',
                        target: '_blank',
                        title: 'Privalia Twitter'
                    }
                }, {
                    icon: IcInstagram_1.default,
                    props: {
                        href: '//instagram.com/privalia_es',
                        target: '_blank',
                        title: 'Privalia Instagram'
                    }
                }, {
                    icon: IcBlog_1.default,
                    props: {
                        href: '//blog.es.privalia.com/',
                        target: '_blank',
                        title: 'Privalia Blog'
                    }
                }, {
                    icon: IcYoutube_1.default,
                    props: {
                        href: '//www.youtube.com/user/Privalia',
                        target: '_blank',
                        title: 'Privalia YouTube'
                    }
                }, {
                    icon: IcLinkedin_1.default,
                    props: {
                        href: '//www.linkedin.com/company/privalia',
                        target: '_blank',
                        title: 'Privalia LinkedIn'
                    }
                }],
            title: 'Síguenos en'
        }
    }
};
exports.default = configuration;
